<script>
import { Line } from 'vue-chartjs'

// const brandPrimary = '#20a8d8'
const brandSuccess = '#4dbd74'
const brandInfo = '#63c2de'
const brandDanger = '#f86c6b'

function convertHex (hex, opacity) {
  hex = hex.replace('#', '')
  const r = parseInt(hex.substring(0, 2), 16)
  const g = parseInt(hex.substring(2, 4), 16)
  const b = parseInt(hex.substring(4, 6), 16)

  const result = 'rgba(' + r + ',' + g + ',' + b + ',' + opacity / 100 + ')'
  return result
}
 

export default {
  extends: Line,
  props: ['height'],
    data () {
    return { 
    }
  },

  methods:
  {
    temp_fun()
    {
       var _this=this
        var temp=[]
           this.$http.get('/api/companies/monthReport') .then(function (response) {
              temp = response.data
             
              _this.chart(temp)

                })
                .catch(function (error) {
                  console.log("error in chart");
                });
    },
    chart(temp){
       var date = new Date(), y = date.getFullYear(), m = date.getMonth();
       var firstDay = new Date(y, m, 1);
       var lastDay = new Date(y, m + 1, 0);
       var year1=firstDay.getFullYear()
       var month1=firstDay.getMonth();
       var day1=firstDay.getDate();
       var year2=lastDay.getFullYear()
       var month2=lastDay.getMonth()+1;
       var day2=lastDay.getDate();
       var nextday
       var elements = day2 
       var data1 = []
       var label =[]
       var dates = []
       var nxtdt = 1
       var valuearr=[]
       var datearr =[]
       var sumarr =[]
       var ch =0
       var val = 0 
       var largest =0
       var step = 0
            for(var i=1;i<=day2;i++)
              {
                label.push(i)
                if(i ==1){
                  dates.push(firstDay)
                }
                else{
                  var nxtdt = nxtdt + 1
                  var nextday = new  Date(year1,month1,nxtdt)
                  dates.push(nextday)
                }
              }

            if(temp.length == 0){
              largest = 1000;
              step = largest/5;
              for(var j = 0 ;j < dates.length ; j++){  
                      data1.push(0)
                    }
            }else{
              for(var l = 0 ;l<temp.length;l++){
                        valuearr = Object.values(temp[l])
                        datearr.push(new Date(valuearr[0]))
                        sumarr.push(valuearr[1])
                    } 
            function getMaxOfArray(sumarr) {
              return Math.max.apply(null, sumarr);
            }
            largest = getMaxOfArray(sumarr)
            step = (largest/5)
            for(var n =0;n<dates.length;n++){
                var tmpdy1 = new Date(dates[n]).getDate()
                for(var j = 0 ;j < datearr.length ; j++){  
                var tmpdy2 = new Date(datearr[j]).getDate()
                if(tmpdy1 == tmpdy2){
                        ch =1
                        val = sumarr[j]
                        break
                  }else{ch =0} 
                 }
                if(ch == 1){data1.push(val)}
                if(ch == 0){data1.push(0)}
            }
        }

 this.renderChart({
      labels:label,
      datasets: [
        {
          label: 'Quantity',
          backgroundColor: convertHex(brandInfo, 10),
          borderColor: brandInfo,
          pointHoverBackgroundColor: '#fff',
          borderWidth: 2,
          data: data1
        },
      ]
    }, {
      maintainAspectRatio: false,
      legend: {
        display: false
      },
      scales: {
        xAxes: [{
          gridLines: {
            drawOnChartArea: false
          }
        }],
        yAxes: [{
          ticks: {
            beginAtZero: true,
            maxTicksLimit: 0,
            stepSize: largest/5 , 
            suggestedMax: largest
          },
          gridLines: {
            display: true
          }
        }]
      },
      elements: {
        point: {
          radius: 2,
          hitRadius: 10,
          hoverRadius: 4,
          hoverBorderWidth: 3
        }
      }
    })


    }
  },

  mounted () {
   this.temp_fun()
   }

}
</script>


// WEBPACK FOOTER //
// src/views/dashboard/MainChartExample.vue